import { API_URL } from 'constants';

export const CREATE_ABSENCE_QUOTAS_URL = `${API_URL}/api/v1/absencequota/new-year-vacation-procedure`;
